export const config = {
  authRoles: {
    admin: ['ADMIN'], // OnlyAdmin has access
    admin_comercial: ['ADMIN', 'COMERCIAL'], // OnlyAdmin and Comercial has access
    user: ['ADMIN', 'COMERCIAL', 'USER'], // Only Admin & User has access
    guest: ['ADMIN', 'COMERCIAL', 'USER', 'GUEST'] // Everyone has access (Guest not used at the moment)
  }
}